import {
    ADDITIONAL_PERSONAL_DATA_ENDPOINT,
    PERSONAL_DATA_ENDPOINT,
} from "../../endpoints";
import { Nullable } from "../../types";
import { fetcher } from "../../utils";
import {
    convertAdvancedPersonalData,
    convertBasicPersonalData,
    convertBasicPersonalDataSubmissionResponse,
    invertBasicPersonalData,
} from "./converters";
import { AdvancedPersonalData, BasicPersonalData } from "./types";

export const getBasicPersonalData = async ({ testId }: { testId: string }) => {
    const response = await fetcher(PERSONAL_DATA_ENDPOINT, {
        params: { hidden: false, test_id: testId },
    });
    return convertBasicPersonalData(response);
};

export const submitBasicPersonalData = async ({
    testId,
    values,
}: {
    testId: string;
    values: BasicPersonalData;
}) => {
    const response = await fetcher(
        PERSONAL_DATA_ENDPOINT,
        {
            method: "PUT",
            params: { test_id: testId, with_validation: true },
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(invertBasicPersonalData(values)),
        },
        true
    );

    return convertBasicPersonalDataSubmissionResponse(response);
};

export const getAdvancedPersonalData = async ({
    testId,
}: {
    testId: string;
}) => {
    const response = await fetcher(ADDITIONAL_PERSONAL_DATA_ENDPOINT, {
        params: { test_id: testId },
    });

    return convertAdvancedPersonalData(response);
};

export const submitAdvancedPersonalData = async ({
    values,
    testId,
}: {
    values: Partial<Omit<AdvancedPersonalData, "all_race_types">>;
    testId: string;
}) => {
    const response = await fetcher(
        ADDITIONAL_PERSONAL_DATA_ENDPOINT,
        {
            method: "PUT",
            params: { test_id: testId },
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
        },
        true
    );

    return convertAdvancedPersonalData(response);
};

export const getBasicPersonalDataCalculatedValues = async ({
    value,
    fieldId,
    testId,
}: {
    value: Nullable<string | number>;
    fieldId: string;
    testId?: string;
}) => {
    if (!testId) {
        return null;
    }

    const values = {
        person: {
            [fieldId]: value,
        },
    };

    const response = await fetcher(
        PERSONAL_DATA_ENDPOINT,
        {
            method: "PUT",
            body: JSON.stringify(values),
            headers: {
                "Content-Type": "application/json",
            },
            params: { test_id: testId, with_validation: false },
        },
        true
    );

    const data = convertBasicPersonalDataSubmissionResponse(response);

    return data as BasicPersonalData; //! can this object contain errors?
};
